import moment from 'moment/dist/moment'

const formatDate = date => {
  return moment(date).format('LL')
}

export default formatDate
